import { actionPrefix } from "./constants";

const INITIAL_STATE = {
    apiUrl: "/api/v1"
};

const SET_API_URL = `${actionPrefix}/app/SET_API_URL`;

export function setApiUrl(newApiUrl) {
    return {
        type: SET_API_URL,
        payload: {
            apiUrl: newApiUrl
        }
    };
}

export function reducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_API_URL:
            return {
                ...state,
                apiUrl: action.payload.apiUrl
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/app.js